const comic = {
  status: {
    ongoing: '连载中',
    completed: '已完结',
  },
  author: '作者',
  category: '分类',
  tags: '标签',
  views: '阅读量',
  rating: '评分',
  chapters: '章节列表',
  chapterCount: '共 {{count}} 话',
  latestUpdate: '最近更新',
  startReading: '开始阅读',
  continueReading: '继续阅读',
  description: '作品简介',
  backToList: '返回列表',
  readingExperience: '下拉式阅读体验',
  scrollHint: '向下滑动即可连续阅读，享受流畅的漫画体验',
  relatedComics: '相关推荐',
};

export default comic;